module.exports = __webpack_public_path__ + "media/images/element/middle-school-90e5d457c24144d634de25dae536e840.svg";